import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./i18n/I18nContext";
import Home from "./pages/Home";
import Simulateur from "./pages/Simulateur";
import Cabinet from "./pages/Cabinet";
import Test from "./pages/Test";
import Offres from "./pages/Offres";
import Auth from "./pages/Auth";
import EspaceClient from "./pages/EspaceClient";
import Admin from "./pages/Admin";
import PaiementSucces from "./pages/PaiementSucces";
import PaiementAnnule from "./pages/PaiementAnnule";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <AuthProvider>
      <I18nProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/simulateur" element={<Simulateur />} />
          <Route path="/le-cabinet" element={<Cabinet />} />
          <Route path="/test" element={<Test />} />
          <Route path="/connexion" element={<Auth />} />
          <Route path="/espace-client" element={<EspaceClient />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/offres" element={<Offres />} />
          <Route path="/paiement/succes" element={<PaiementSucces />} />
          <Route path="/paiement/annule" element={<PaiementAnnule />} />
        </Routes>
        </BrowserRouter>
      </I18nProvider>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
